<template>
  <div class="address_picker">
    <a-input
      :value="props.lng"
      :onChange="lngChange"
      :placeholder="lngPlaceholder"
      :style="{ width: props.width }"
    ></a-input>
    <a-input
      :value="props.lat"
      :onChange="latChange"
      :placeholder="latPlaceholder"
      :style="{ width: props.width }"
    ></a-input>
    <a-button @click="handleOpen" shape="circle" type="link">
      <EnvironmentOutlined />
    </a-button>
    <a-modal
      :open="open"
      title="经纬度选择器"
      :footer="null"
      @cancel="handleCancel"
      class="action-form-model"
      :destroyOnClose="true"
    >
      <div class="picker_top">
        <span :style="{ lineHeight: '16px' }">
          <span v-if="pickLat">
            经度: {{ pickLng }}
            <br />
            纬度: {{ pickLat }}
          </span>
          <span v-else>点击地图获取经纬度</span>
        </span>
        <a-button @click="handleSave" type="primary">保存</a-button>
      </div>
      <baseMap ref="mapRef" class="map" @mounted="mapMounted" />
    </a-modal>
  </div>
</template>

<script setup>
  import {
    defineProps,
    defineEmits,
    computed,
    ref,
    onMounted,
    toRefs,
  } from 'vue'
  import { EnvironmentOutlined } from '@ant-design/icons-vue'
  import { message } from 'ant-design-vue'
  import baseMap from '@/components/map/base_map'
  const emit = defineEmits()

  const props = defineProps({
    lat: {
      required: true, //是否必传
    },
    lng: {
      required: true, //是否必传
    },
    label: {
      type: String, // 参数类型
      required: true, //是否必传
    },
    value: {
      required: true, //是否必传
    },
    placeholder: {
      type: String, // 参数类型
    },
    width: {
      default: '43%',
    },
  })
  //1、表单逻辑
  const latPlaceholder = props?.placeholder ? props?.label?.placeholder : `纬度`
  const lngPlaceholder = props?.placeholder ? props?.label?.placeholder : `经度`
  function latChange(data) {
    emit('update:lat', data.target.value)
  }
  function lngChange(data) {
    emit('update:lng', data.target.value)
  }

  console.log(props.lat, props.lng, 777, props)

  //2、经纬度选择器逻辑
  const open = ref(false)
  const mapRef = ref()
  const pickLat = ref(props.lat)
  const pickLng = ref(props.lng)
  function handleOpen() {
    open.value = true
  }
  function setLatitude(lat) {
    pickLat.value = lat
  }
  function setLongitude(lng) {
    pickLng.value = lng
  }
  function mapMounted(map) {
    pickLat.value = props.lat
    pickLng.value = props.lng
    //配置工具栏
    map.pm.setLang('zh')

    let center = ['22.744976', '114.524402'] //中心纬经度
    if (props.lat && props.lng) {
      center = [props.lat, props.lng]
    }
    const normalConfig = {
      drawText: false,
      editMode: false,
      drawMarker: false,
      drawCircle: false,
      cutPolygon: false,
      rotateMode: false,
      drawPolygon: false,
      removalMode: false,
      drawPolyline: false,
      drawRectangle: false,
      drawCircleMarker: false,
    }

    if (props.lat && props.lng) {
      //有传入标点，进入编辑模式

      //居中
      mapRef.value.flyTo(props.lng, props.lat)
      //绘制标点
      window.L.marker(center)
        .on('pm:edit', function fn(e) {
          //监听编辑模式
          setLongitude(e.layer._latlng.lng)
          setLatitude(e.layer._latlng.lat)
        })
        .addTo(map)

      //配置编辑模式
      map.pm.addControls({
        ...normalConfig,
        dragMode: true,
      })

      //进入编辑模式
      map.pm.enableGlobalEditMode()
    } else {
      //如果没有传入经纬度则进入选点模式
      map.on('pm:create', function fn(e) {
        setLongitude(e.marker._latlng.lng)
        setLatitude(e.marker._latlng.lat)
        //禁用继续标点
        map.pm.disableDraw()
        map.pm.enableGlobalEditMode()
        map.pm.addControls({
          drawMarker: false,
          dragMode: true,
        })

        //监听编辑事件
        e.layer.on('pm:edit', function fn(e) {
          setLongitude(e.layer._latlng.lng)
          setLatitude(e.layer._latlng.lat)
        })
      })

      map.pm.addControls(normalConfig)
      //进入绘制模式
      map.pm.enableDraw('Marker')
    }
  }

  function handleCancel() {
    open.value = false
  }
  function handleSave() {
    if (pickLat.value) {
      lngChange({ target: { value: pickLng.value } })
      latChange({ target: { value: pickLat.value } })
      handleCancel()
    } else {
      message.warn('请点击地图点击地图获取经纬度')
    }
  }
</script>

<style lang="less" scoped>
  .address_picker {
    display: flex;
    align-items: center;
    .ant-btn {
      font-size: 23px;
      line-height: 0px;
      height: 30px;
      .anticon {
        margin: 0 !important;
      }
    }
  }
  .map {
    height: calc(100vh - 184px) !important;
    width: calc(100vw - 80px) !important;
  }
  .picker_top {
    display: flex;
    justify-content: space-between;
    padding: 20px 10px;
  }
</style>
